import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { DrishtiSession } from '../services/drishtiSession';

// Its own slice, not userData, so a technician can hold either token, both, or neither.
export interface DrishtiUserInfoState {
    session: DrishtiSession | undefined;
}

export const initialState: DrishtiUserInfoState = {
    session: undefined,
};

export const drishtiUserInfoSlice = createSlice({
    name: 'drishtiUserInfo',
    initialState,
    reducers: {
        updateDrishtiSession: (state, action: PayloadAction<DrishtiSession>) => {
            state.session = action.payload;
        },
        clearDrishtiSession(state) {
            state.session = undefined;
        },
    },
});

export const drishtiUserInfoReducer = drishtiUserInfoSlice.reducer;
export const { updateDrishtiSession, clearDrishtiSession } = drishtiUserInfoSlice.actions;
